import React, { useEffect, useMemo, useState } from "react";
import Modal from "@mui/material/Modal";
import {
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import {
  formatToCedula,
  containsOnlyNumbers,
  passportFormat,
  cedulaIsValid,
} from "../../utils/helpers";
import { botonNoDialog, botonVerPerfilProfileCard } from "../../global/styles";
import InfoLabel from "../common/infoLabel";
import CustomRadioButton from "../consulta/solicitudes/customRadioButton";
import DocumentosRequeridosList from "../consulta/solicitudes/documentosRequeridosList";
import CustomDataPicket from "../consulta/solicitudes/CustomDataPicket";
import ModalLoading from "../common/modalLoading";
import colors from "../../../config/colors";
import CargarDocumentoV2 from "../cargarArchivos/cargaDocumentosV2";
import CustomButton from "../common/customButton";
import * as apiService from '../../../api'
import { useSnackbar } from "notistack";
import CustomLabel from "../common/customLabel";
import { useSelector } from "react-redux";

const ModalGuardarInformacionBancaria = ({
  open,
  cerrarModal,
  contratoAfiliado,
  informacionBancaria = null
}) => {

  const cuentas = [
    {
      id: 1,
      descripcion: "Ahorro",
    },
    {
      id: 2,
      descripcion: "Corriente",
    },
  ];

  const documentosRequeridos = useMemo(() => {
    return [
      {
        cantidadDocumentos: 2,
        requerimientosDocumentos: [
          {
            id: 111,
            name: 'Cédula',
            requerido: true,
            formato: ['image/jpeg', 'image/png', 'application/pdf'],
            qtyFiles: 3,
            size: 2097152
          },
          {
            id: 122,
            name: 'Certificación de cuenta emitida por el banco, estado de cuenta, comprobante de transferencia y/o captura de pantalla de aplicación del banco con los detalles de la cuenta',
            requerido: true,
            formato: ['image/jpeg', 'image/png', 'application/pdf'],
            qtyFiles: 3,
            size: 2097152
          }
        ]
      }
    ];
  },[]) 
  

  const [numeroCuenta, setNumeroCuenta] = useState("");
  const [tipoCuenta, setTipoCuenta] = useState("");
  const [banco, setBanco] = useState([]);
  const [bancoSeleccionado, setBancoSeleccionado] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [nombreTitularCuentaBanco, setNombreTitularCuentaBanco] = useState("");
  const [cedulaTitularCuentaBanco, setCedulaTitularCuentaBanco] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [documentosFaltantes, setDocumentosFaltantes] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [nucleoFamiliar,setNucleoFamiliar] = useState(null);
  const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado);


   const requiredLabel = (
      <h4 style={{ color: colors.error, padding: 0, margin: 0 }}>
        Este campo es requerido.*
      </h4>
    );

  const handleInvalid = (event) => {
    event.target.setCustomValidity(
      "Por favor, seleccione una de las opciones disponibles."
    );
  };

  const handleInput = (event) => {
    event.target.setCustomValidity("");
  };

  const handlerSelectTipoDocumento = ({ target }) => {
    setTipoDocumento(target.value);
    setCedulaTitularCuentaBanco("");
  };

  const ordenarBancos = (result) => {
    let datosOrdneados = [];
    result.map((x) => {
      datosOrdneados.push({
        id: x.codigo,
        nombre: x.descripcion,
      });
    });
    setBanco(datosOrdneados);
  };

  const mostrarMensaje = (nota, tipo) => {
      enqueueSnackbar(<span dangerouslySetInnerHTML={{ __html: nota }} />, {
        variant: tipo,
        action: (key) => (
          <Button
            style={{ color: "white", fontWeight: "bold" }}
            onClick={() => closeSnackbar(key)}
          >
            X
          </Button>
        ),
      });
    };

  const handleGuardarInformacionBancaria = () => {
    debugger
    if (numeroCuenta.trim() === "" || 
        tipoCuenta.trim() === "" || 
        bancoSeleccionado === undefined || 
        nombreTitularCuentaBanco.trim() === "" ||
        tipoDocumento.trim() === "" ||
        cedulaTitularCuentaBanco.trim() === ""
      ) {
        mostrarMensaje("Debes completar todos los campos", "warning")
        return 
      }

      if(uploadedDocuments.length === 0 || 
         uploadedDocuments.filter(u=>u.type === "Cédula").length === 0 || 
         uploadedDocuments.filter(u=>u.type.includes("Certificación")).length === 0 ){
          mostrarMensaje("Debe de agregar los documentos requeridos", "warning")
        return 
      }

      if (numeroCuenta.length < 8){
        mostrarMensaje("El número de cuenta utilizado no es válido, favor verificar","warning");
        return
      }

      if (!cedulaIsValid(cedulaTitularCuentaBanco) &&
            tipoDocumento === "Cedula") {
            mostrarMensaje("Cédula de identidad invalida, por favor verificar","warning");
            return
          }

      let miembroBasico = [];
      let miembroComplementario = [];
      if (nucleoFamiliar != null) {
        if (nucleoFamiliar.basico){
          miembroBasico = nucleoFamiliar.basico.filter(b=>b.cedula === cedulaTitularCuentaBanco);
        }

         if (nucleoFamiliar.complementario){
          miembroComplementario = nucleoFamiliar.complementario.filter(b=>b.cedula === cedulaTitularCuentaBanco);
        }

        if (miembroBasico.length === 0 && miembroComplementario.length === 0) {
          mostrarMensaje("Cédula de identidad debe pertenecer a un miembro del nucleo familiar, por favor verificar","warning");
        return
        }

      } else {
        apiService.afiliado
                  .getNucleoFamiliar(infoAfiliado.codigoAfiliado)
                  .then(response=> {
                    setNucleoFamiliar(response.data.result)
                  })
                  .catch(console.log)
        mostrarMensaje("Cédula de identidad debe pertenecer a un miembro del nucleo familiar, por favor verificar","warning");
        return
      }
      
      setModalLoading(true);
      apiService.utility.postSolicitudInformacionBancariaAfiliado(
        informacionBancaria ? informacionBancaria.codigo : 0,
        contratoAfiliado,
        bancoSeleccionado.id, 
        nombreTitularCuentaBanco, 
        numeroCuenta,
        cedulaTitularCuentaBanco,
        tipoCuenta === "Ahorro" ? 1 : 2,
        tipoDocumento === "Cedula" ? 1 : 2,
        uploadedDocuments)
        .then(response => {
          if (response.data.result) {
            handleCerrarModal()
          }
        })
        .catch(console.log)
        .finally(_ =>{
          setModalLoading(false);
        })
        


  }

  useEffect(() => {
    apiService.afiliado
    .getNucleoFamiliar(infoAfiliado.codigoAfiliado)
    .then(response=> {
      setNucleoFamiliar(response.data.result)
    })
    .catch(console.log)

      apiService.reembolso
        .GetBancos()
        .then((response) => {
          ordenarBancos(response.data.result);
        })
        .catch();
  },[])

  useEffect(() => {

    if (informacionBancaria){
      setNombreTitularCuentaBanco(informacionBancaria.nombreApellido)
      setTipoDocumento(informacionBancaria.tipoDocumento === 1 ? "Cedula" : "Pasaporte")
      setCedulaTitularCuentaBanco(informacionBancaria.numeroDocumento)
      setNumeroCuenta(informacionBancaria.numeroCuenta)
      setTipoCuenta(informacionBancaria.tipoCuenta === 1 ? "Ahorro" : "Corriente")
      const filteredBanco = banco.filter(b=>b.id === informacionBancaria.idBanco)[0]
      setBancoSeleccionado(filteredBanco)
    }

  },[informacionBancaria])

  const handleCerrarModal = () => {
    setNombreTitularCuentaBanco("")
    setTipoDocumento("")
    setCedulaTitularCuentaBanco("")
    setNumeroCuenta("")
    setTipoCuenta("")
    setBancoSeleccionado("")
    cerrarModal()
  }


  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        sx={{
          paddingTop: { xs: 0, md: 5, lg: 5 },
          height: "auto",
          overflow: "auto",
        }}
      >
          <Grid
            container
            justifyContent={"center"}
            style={{ fontFamily: "montserrat" }}
          >
            <Grid
              item
              md={8}
              xs={12}
              lg={6}
              style={{ backgroundColor: colors.white }}
              sx={{ padding: { xs: 3 } }}
            >
              <Grid
                item
                md={12}
                xs={12}
                marginBottom={7}
                sx={{ marginTop: { xs: 5, md: 0 } }}
              >
                <CustomLabel 
                  style={{fontSize: '1.5rem', 
                          marginTop: '10px', 
                          color: colors.primaryDark,
                          fontWeight: 'bold',
                          fontFamily: 'Montserrat'}} >
                  Registro de cuenta bancaria
                </CustomLabel>
                <CustomLabel 
                  style={{
                          fontSize: '1.1rem',
                          marginTop: '20px',
                          fontFamily: 'Montserrat',
                          color: colors.grayDark,
                          fontStyle: 'italic'

                          }} >
                  Por favor, completa la información de tu cuenta bancaria. Esta sera utilizada para procesar tus reembolsos.
                </CustomLabel>
              </Grid>
              <Grid container spacing={1}>

                <Grid item md={12} xs={12}>
                    <Grid container>
                      <Grid container spacing={2} marginTop={3}>
                        <Grid item md={12} xs={12}>
                          <Grid marginTop={3}>
                            <InfoLabel
                              title={"Información bancaria"}
                              info={"Completar la información bancaria"}
                            />
                          </Grid>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Grid id="NumeroCuenta">
                            <Grid marginBottom={2}>
                              <InfoLabel
                                title={"Número de cuenta "}
                                style={{ fontSize: 10, fontWeight: 500 }}
                              />
                            </Grid>
                            <FormControl fullWidth>
                              <TextField
                                id="field-numero-cuenta"
                                type="text"
                                placeholder="123..."
                                onChange={(event) => {
                                  setNumeroCuenta(
                                    containsOnlyNumbers(event.target.value)
                                  );
                                }}
                                value={numeroCuenta}
                                required={true}
                                helperText={
                                  !numeroCuenta ? requiredLabel : ""
                                }
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Grid id="Cuenta">
                            <Grid marginBottom={2}>
                              <InfoLabel
                                title={"Tipo de cuenta"}
                                style={{ fontSize: 10, fontWeight: 500 }}
                              />
                            </Grid>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "0vh",
                              }}
                            >
                              <input
                                id="field-numero-cuenta"
                                style={{
                                  margin: "1px",
                                  padding: "1px",
                                  width: "1px",
                                  height: "1px",
                                  border: "1px solid white",
                                }}
                                required={true}
                                onInvalid={handleInvalid}
                                onInput={handleInput}
                                readOnly={tipoCuenta ? true : false}
                              />
                            </div>
                            <Grid spacing={1} container>
                              {cuentas.map((x) => (
                                <Grid item md={6} xs={12}>
                                  <CustomRadioButton
                                    id={x.id}
                                    name={x.descripcion}
                                    selected={
                                      !tipoCuenta
                                        ? false
                                        : x.descripcion !== tipoCuenta
                                        ? false
                                        : true
                                    }
                                    nameSelected={(x) => setTipoCuenta(x)}
                                    editSelected={tipoCuenta}
                                    style={{ padding: 0, paddingInline: 10 }}
                                  />
                                </Grid>
                              ))}
                              <FormHelperText sx={{ color: "red" }}>
                                {!tipoCuenta ? requiredLabel : ""}
                              </FormHelperText>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item md={6} xs={12} paddingTop={0}>
                          <Grid id="Banco">
                            <Grid marginBottom={2}>
                              <InfoLabel
                                title={"Banco"}
                                style={{ fontSize: 10, fontWeight: 500 }}
                              />
                            </Grid>
                            <CustomDataPicket
                              id="picker-banco"
                              title="Banco"
                              data={banco}
                              valueSelected={
                                !bancoSeleccionado
                                  ? ""
                                  : !bancoSeleccionado.nombre
                                  ? bancoSeleccionado
                                  : bancoSeleccionado.nombre
                              }
                              selected={(value) => setBancoSeleccionado(value)}
                              customStyle={{ height: "auto" }}
                              required={!isValid}
                              helperText={
                                 !bancoSeleccionado
                                  ? requiredLabel
                                  : ""
                              }
                            />
                          </Grid>
                        </Grid>
                        <Grid item md={6} xs={12} paddingTop={0}>
                          <Grid>
                            <Grid marginBottom={2}>
                              <InfoLabel
                                title={"Nombres y apellidos"}
                                style={{ fontSize: 10, fontWeight: 500 }}
                              />
                            </Grid>
                            <FormControl fullWidth>
                              <TextField
                                id="field-nombre-titular-cuenta"
                                type="text"
                                placeholder="Juan Perez"
                                onChange={(event) => {
                                  setNombreTitularCuentaBanco(
                                    event.target.value
                                  );
                                }}
                                value={nombreTitularCuentaBanco}
                                required={true}
                                helperText={
                                  !nombreTitularCuentaBanco ? requiredLabel : ""
                                }
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Grid container>
                            <InfoLabel
                              title={"Tipo de documento"}
                              style={{ fontSize: 10, fontWeight: 500 }}
                            />
                            <FormControl fullWidth>
                              <select
                                required={!isValid}
                                id="select-tipoDocumento"
                                value={tipoDocumento}
                                onChange={handlerSelectTipoDocumento}
                                style={{
                                  width: "100%",
                                  padding: 8,
                                  fontSize: 16,
                                  border: "solid 2px #3DAE2B",
                                  borderRadius: 10,
                                  height: 60,
                                }}
                              >
                                <option value=""></option>
                                <option value="Cedula">Cédula</option>
                              </select>
                              <FormHelperText sx={{ color: "red" }}>
                                { !tipoDocumento
                                  ? requiredLabel
                                  : ""}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          {tipoDocumento ? (
                            <Grid container>
                              <InfoLabel
                                title={
                                  tipoDocumento === "Cedula"
                                    ? "Cédula"
                                    : tipoDocumento === "Pasaporte"
                                    ? "Pasaporte"
                                    : "Documento"
                                }
                                style={{ fontSize: 10, fontWeight: 500 }}
                              />
                              <FormControl fullWidth>
                                <TextField
                                  id="field-documento-cuenta"
                                  type="text"
                                  onChange={(event) => {
                                    if (tipoDocumento === "Cedula") {
                                      setCedulaTitularCuentaBanco(
                                        formatToCedula(event.target.value)
                                      );
                                    } else if (tipoDocumento === "Pasaporte") {
                                      setCedulaTitularCuentaBanco(
                                        passportFormat(
                                          event.target.value.toUpperCase()
                                        )
                                      );
                                    }
                                  }}
                                  value={cedulaTitularCuentaBanco}
                                  required={true}
                                  helperText={
                                  !cedulaTitularCuentaBanco ? requiredLabel : ""
                                }
                                />
                              </FormControl>
                            </Grid>
                          ) : null}
                        </Grid>
                      </Grid>
              
                      <Grid container marginTop={3} mb={5}>
                        <DocumentosRequeridosList
                          data={{
                            id: 1,
                            descripcion: "Cedula de identidad",
                          }}
                        />
                      </Grid>

                      <Grid md={12} xs={12}>
                        <CargarDocumentoV2
                          onFilesChange={setUploadedDocuments}
                          requiredDocuments={documentosRequeridos[0].requerimientosDocumentos}
                          missingDocuments={setDocumentosFaltantes}
                        />
                      </Grid>
                      
                    </Grid>
                  
                </Grid>
                <Grid container padding={5} spacing={4}>
                  <Grid item md={6} xs={12} textAlign={"center"}>
                    <CustomButton
                      id="btn-cancelar"
                      onClick={handleCerrarModal}
                      type={"button"}
                      sx={{
                        ...botonNoDialog,
                        border: `0 solid ${colors.primary}`,
                        cursor: "pointer",
                        width: 250,
                        height: 50,
                        borderRadius: 100,
                        fontFamily: "Montserrat",
                      }}
                    >
                      Cancelar
                    </CustomButton>
                  </Grid>
                  <Grid item md={6} xs={12} textAlign={"center"}>
                    <CustomButton
                      id="btn-guardar"
                      type="sumbit"
                      sx={{
                        ...botonVerPerfilProfileCard,
                        border: `0 solid ${colors.primary}`,
                        cursor: "pointer",
                        width: 250,
                        height: 50,
                        borderRadius: 100,
                        backgroundColor: colors.primary,
                        fontFamily: "Montserrat",
                      }}
                      onClick={handleGuardarInformacionBancaria}
                    >
                      Guardar
                    </CustomButton>
                  </Grid>
                </Grid>
                <ModalLoading open={modalLoading} />
              </Grid>
            </Grid>
          </Grid>
      </Modal>
    </div>
  );
};

export default ModalGuardarInformacionBancaria;
